import { render, staticRenderFns } from "./VesselsModal.vue?vue&type=template&id=96182a12&scoped=true&"
import script from "./VesselsModal.vue?vue&type=script&lang=js&"
export * from "./VesselsModal.vue?vue&type=script&lang=js&"
import style0 from "./VesselsModal.vue?vue&type=style&index=0&id=96182a12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96182a12",
  null
  
)

export default component.exports